var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 11.4286L14.509 8L8.8 4.57143V11.4286ZM21.516 2.48C21.659 3.01714 21.758 3.73714 21.824 4.65143C21.901 5.56571 21.934 6.35429 21.934 7.04L22 8C22 10.5029 21.824 12.3429 21.516 13.52C21.241 14.5486 20.603 15.2114 19.613 15.4971C19.096 15.6457 18.15 15.7486 16.698 15.8171C15.268 15.8971 13.959 15.9314 12.749 15.9314L11 16C6.391 16 3.52 15.8171 2.387 15.4971C1.397 15.2114 0.759 14.5486 0.484 13.52C0.341 12.9829 0.242 12.2629 0.176 11.3486C0.0990001 10.4343 0.0659999 9.64571 0.0659999 8.96L0 8C0 5.49714 0.176 3.65714 0.484 2.48C0.759 1.45143 1.397 0.788572 2.387 0.502857C2.904 0.354286 3.85 0.251428 5.302 0.182857C6.732 0.102857 8.041 0.0685714 9.251 0.0685714L11 0C15.609 0 18.48 0.182857 19.613 0.502857C20.603 0.788572 21.241 1.45143 21.516 2.48Z",
    fill: "url(#paint0_linear_1773_21143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1773_21143",
    x1: 0,
    y1: 8,
    x2: 22,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.f652307fb905c78085a784d0e608d318.svg";
export { ForwardRef as ReactComponent };